<template>
    <div class="search" :class="{focus: isFocus}">
        <div class="box"><input type="text" maxlength="20" placeholder="请输入" @blur="isFocus = false" ref="kw"></div>
        <div class="icon" @click="isFocus = !isFocus"></div>
    </div>
</template>
<script>
export default {
    name: 'search',
    props: {
        
    },
    data() {
        return {
            isFocus: false
        }
    },
    created() {
        
    },
    watch:{
        isFocus(v) {
            if (v) {
                console.log(this.$refs.kw);
                this.$refs.kw.focus();
            }
        }
    },
    methods: {
        
    }
}
</script>
<style lang="less">
.search{
    position: absolute;
    top: 0;
    right: 0;
    .box{
        width: 200px;
        position: relative;
        z-index: 5;
        visibility: hidden;
        opacity: 0;
        transition: 0.3s;
        input{
            border: none;
            height: 40px;
            padding: 0 10px;
            color: var(--front-color);
        }
    }
    .icon{
        position: absolute;
        top: 50%;
        right: 10px;
        width: 20px;
        height: 20px;
        transform: translate(0, -50%);
        transition: 0.3s;
        cursor: pointer;
        &:before{
            content: '';
            position: absolute;
            border: solid 2px var(--front-color);
            width: 100%;
            height: 100%;
            border-radius: 50%;
            box-sizing: border-box;
            transition: 0.3s;
        }
        &:after{
            content: '';
            position: absolute;
            width: 2px;
            height: 7px;
            background-color: var(--front-color);
            bottom: 0;
            right: 0;
            transform: rotate(-45deg);
            transition: 0.3s;
        }
    }
    &.focus{
        .box{
            visibility: visible;
            opacity: 1;
        }
        .icon{
            width: 200px;
            height: 40px;
            right: 0;
            &:before{
                border-radius: 4px;
            }
            &:after{
                opacity: 0;
            }
        }
    }
}
</style>